import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { LocalizationService } from '../../../localization/localization.service';
import {
  supportUrlsLocalized,
  URLS,
} from '../../../shared/constants/urls.constant';
import { SupportDataDispatcher } from '../../../support-data/support-data.dispatcher';
import { SupportDataStore } from '../../../support-data/support-data.store';
import { Support } from '../../../support-data/models/support.model';
import { Observable } from 'rxjs';
import { SUPPORT_EMAIL } from '../../support.data';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportComponent implements OnInit {
  @Input() isCompact = false;
  @Input() showFAQ = true;

  @Output() emailClick = new EventEmitter<void>();
  @Output() faqClick = new EventEmitter<void>();

  supportUrl: string;
  support$: Observable<Support>;
  placeholderRows = Array(3);
  supportEmail = SUPPORT_EMAIL;

  constructor(
    private _localizationService: LocalizationService,
    private _supportDataDispatcher: SupportDataDispatcher,
    private _supportDataStore: SupportDataStore
  ) {}

  ngOnInit() {
    this.supportUrl = supportUrlsLocalized(
      URLS.SUPPORT,
      this._localizationService.getLocale()
    );

    this._supportDataDispatcher.fetchSupport();

    this.support$ = this._supportDataStore.getSupport();
  }
}
